import { createContext, useContext } from "react";
import { ITaggerQueries } from "./query-services/tagger-queries/tagger-queries";
import { IBenchmarkQueries } from "./query-services/benchmark/benchmark-queries";
import { IPlaidQueries } from "./query-services/plaid/plaid-queries";
import { IGeneralQueries } from "./query-services/general/general-queries";
import { IClientQueries } from "./query-services/clients/clients-queries";

export const TaggerQueriesContext = createContext<ITaggerQueries>({} as ITaggerQueries);
export const BenchmarkQueriesContext = createContext<IBenchmarkQueries>({} as IBenchmarkQueries);
export const PlaidQueriesContext = createContext<IPlaidQueries>({} as IPlaidQueries);
export const GeneralQueriesContext = createContext<IGeneralQueries>({} as IGeneralQueries);
export const ClientQueriesContext = createContext<IClientQueries>({} as IClientQueries);

export const useTaggerQueries = (): ITaggerQueries => useContext<ITaggerQueries>(TaggerQueriesContext);
export const useBenchmarkQueries = (): IBenchmarkQueries => useContext<IBenchmarkQueries>(BenchmarkQueriesContext);
export const usePlaidQueries = (): IPlaidQueries => useContext<IPlaidQueries>(PlaidQueriesContext);
export const useGeneralQueries = (): IGeneralQueries => useContext<IGeneralQueries>(GeneralQueriesContext);
export const useClientQueries = (): IClientQueries => useContext<IClientQueries>(ClientQueriesContext);
